import React from 'react'

const Terms = () => (
  <main id="terms">
    <section class="center-vert" style={{alignItems: "flex-start"}}>
      <h1 style={{alignSelf: "center"}}>Terms and Conditions</h1>
      <p class="left"><strong>BACKGROUND</strong></p>
      <ol type="A">
        <li>The Performer is a professional entertainment group known as “The Guests”.</li>
        <li>The Client wishes to engage the Performer subject to the terms and conditions as follows:</li>
      </ol>
      <p class="left"><strong>NOTE: If the Client provides their own contract upon booking, the Performer will adhere to the standards of the Client should they override any of the following:</strong></p>
      <p class="left"><strong>IN CONSIDERATION OF</strong> and as a condition of the Client hiring the Performer and other valuable consideration, the receipt and sufficiency of which consideration is acknowledged here, the parties to these terms agree as follows:</p>
      <ol>
        <li>	
          <p class="left"><strong>Business Address of the Performer</strong></p>
          <p class="left">
            Any payments by check or money order should be made out to “David Buckley c/o The Guests”. The Performer’s business address is as follows:
            <blockquote>
              David Buckley<br/>
              c/o The Guests<br/>
              475 S 400 W<br/>
              Provo, UT 84601
            </blockquote>
          </p>
        </li>
        <li>
          <p class="left"><strong>Payment</strong></p>
          <p class="left">
            All payment details shall be explicitly identified by Performer in an Invoice to Client upon booking of the gig. Agreement to the Invoice implies agreement to these terms.
          </p>
        </li>
        <li>
          <p class="left"><strong>Cancellation by the Client</strong></p>
          <p class="left">
            If the Client cancels the booking within 14 days of the date of the event, the Client will pay the Performer 50% of the agreed fee (specified in the Invoice) to offset the loss of business from declining other bookings and compensate for time spent preparing for performance.
          </p>
        </li>
        <li>
          <p class="left"><strong>Cancellation by the Performer</strong></p>
          <p class="left">
            The Performer agrees to issue written notice if cancellation is necessary up to 14 days prior to performance date but does not assume any monetary liability to the Client.
          </p>
        </li>
        <li>
          <p class="left"><strong>Force Majeure</strong></p>
          <p class="left">
            Neither the Performer nor the Client will be held liable for any failure to perform its obligations under these terms where such breach is due to any of the following: acts or regulations of public authorities, labor difficulties or strike, inclement weather, epidemic, interruption or delay of transportation service, acts of God, or any other legitimate cause beyond the reasonable control of the Performer and the Client.
          </p>
        </li>
        <li>
          <p class="left"><strong>Sickness and Accidents</strong></p>
          <p class="left">
            The Performer agrees to meet its obligations under this Agreement subject to legitimate incapacity by sickness or accident.
          </p>
        </li>
        <li>
          <p class="left"><strong>Merchandising</strong></p>
          <p class="left">
            The Performer may offer CDs, tapes, and other such items for sale at the Performance. The Client will provide a suitable area with reasonable visibility and accessibility to facilitate merchandising.
          </p>
        </li>
        <li>
          <p class="left"><strong>Indemnification</strong></p>
          <p class="left">
            The Performer is responsible only for its own conduct. The Performer will be compensated by the Client, its agents or guests. The Client indemnifies and holds the Performer harmless for any and all property damage or personal injury that results from or related to the Performance that is not directly caused by the Performer.
          </p>
        </li>
        <li>
          <p class="left"><strong>Governing Law</strong></p>
          <p class="left">
            These terms will be governed by, and construed in accordance with, the laws of the State of Utah for the enforcement of the terms or any arbitration award or decision arising from these terms.
          </p>
        </li>
        <li>
          <p class="left"><strong>Covenant of Good Faith Fair Dealing</strong></p>
          <p class="left">The Client and the Performer agree to perform their obligations under these terms, in all respects, in good faith.</p>
        </li>
      </ol>      
    </section>
  </main>
)

export default Terms